/** @ignore */
function _isPlainObject(value) {
    return Object.prototype.toString.call(value) === '[object Object]';
}

export { _isPlainObject };
//# sourceMappingURL=isPlainObject.js.map
